const KNOWN = {
  green: "#16A34A", black: "#111827", grey: "#6B7280", gray: "#6B7280",
  blue: "#2563EB", red: "#DC2626", brown: "#92400E", beige: "#D6C7A1",
  maroon: "#7F1D1D", charcoal: "#374151", ivory: "#F5F0E1", gold: "#C9A227",
  white: "#F9FAFB", silver: "#C0C0C0", orange: "#EA580C", yellow: "#CA8A04",
  pink: "#DB2777", purple: "#7C3AED",
};

function resolveHex(name, palette = {}) {
  if (palette[name]) return palette[name];
  const key = name.trim().toLowerCase();
  if (KNOWN[key]) return KNOWN[key];
  return null;
}

export function ColourSwatch({ name, palette, size = "md", showTooltip = true }) {
  const dim = size === "sm" ? "h-4 w-4" : size === "lg" ? "h-7 w-7" : "h-6 w-6";
  const parts = name.replace("/", "-").split("-").map((s) => s.trim());
  const hexes = parts.map((p) => resolveHex(p, palette)).filter(Boolean);
  const gradient = hexes.length >= 2
    ? `linear-gradient(135deg, ${hexes[0]} 0 50%, ${hexes[1]} 50% 100%)`
    : hexes[0] || "#cbd5e1";

  return (
    <span
      title={showTooltip ? name : undefined}
      data-testid={`colour-swatch-${name.toLowerCase()}`}
      className={`inline-block ${dim} rounded-full border-2 border-white shadow ring-1 ring-slate-200`}
      style={{ background: gradient }}
    />
  );
}
